import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { GestionReferidosComponent } from '../gestion-referidos/gestion-referidos.component';
import { NotificacionReferidoService } from '../../../../services/notificacion-referido/notificacion-referido.service';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './detalle-dialog.component.html',
  styleUrls: ['./detalle-dialog.component.css'],
})
export class DetalleDialogComponent {
  usuariosNoMarcados: { [idUsuario: number]: number } = {};
  usuariosEliminados: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<DetalleDialogComponent>,
    private dialog: MatDialog,
    private notificacionReferidoService: NotificacionReferidoService,
    @Inject(MAT_DIALOG_DATA)
    public data: { users: any[]; idNotificacion: number },
  ) {}

  OnReferidosClick(user: any) {
    const dialogRef = this.dialog.open(GestionReferidosComponent, {
      width: '350px',
      data: {
        nombre: user.nombre,
        idDetalle: user.idDetalle,
        idUsuario: user.idNormalizado,
        idNotificacion: user.idNotificacion,
        usuariosNoMarcados: this.usuariosNoMarcados,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;

      const { idUsuario, contador, eliminarUsuario } = result;

      this.usuariosNoMarcados[idUsuario] = contador;

      if (eliminarUsuario) {
        // Quitar de la vista
        this.data.users = this.data.users.filter(
          (u) => u.idNormalizado !== idUsuario,
        );

        // Agregar a eliminados
        this.usuariosEliminados.push(idUsuario);

        // Apagar notificación solo de ese usuario
        if (user.idNotificacion) {
          this.notificacionReferidoService
            .actualizarEstado(user.idNotificacion, false)
            .subscribe({
              error: (err) => console.error('Error actualizando estado', err),
            });
        }
      }
    });
  }

  close(): void {
    // Devuelve todos los usuarios eliminados al padre
    this.dialogRef.close({
      gestiono: this.usuariosEliminados.length > 0,
      usuariosEliminados: this.usuariosEliminados,
    });
  }
}
